import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@mui/material/Button';
import { useConfirm } from 'material-ui-confirm';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import DashboardListPageLayout from 'src/common/components/dashboard/DashboardListPageLayout';
import Icon from 'src/common/components/icons/Icon';
import { dashboardPrimaryActionButtonProps } from 'src/common/components/DashboardPageToolbar';
import Empty from 'src/common/components/Empty';
import useEmailTemplatesStore from 'src/stores/emailTemplatesStore';
import EmailTemplatesManager from './components/EmailTemplatesManager';

export default function EmailTemplatesList() {
  const { t } = useTranslation();
  const confirm = useConfirm();
  const { enqueueSnackbar } = useSnackbar();

  const { templates, isLoading, seedTemplates } = useEmailTemplatesStore(s => s);

  const handleSeed = async () => {
    const { confirmed } = await confirm({
      title: t('system.emails.seedConfirmTitle'),
      description: t('system.emails.seedConfirmDescription'),
      confirmationText: t('confirmProvider.confirmationText'),
      cancellationText: t('confirmProvider.cancellationText'),
    });
    if (!confirmed) return;

    try {
      await seedTemplates();
      enqueueSnackbar(t('system.emails.seedSuccess'), { variant: 'success' });
    } catch {
      enqueueSnackbar(t('system.emails.seedError'), { variant: 'error' });
    }
  };

  return (
    <DashboardListPageLayout
      title={t('system.emails.pageTitle')}
      fill={false}
      isLoading={isLoading && templates.length === 0}
      headerActions={
        <Button
          {...dashboardPrimaryActionButtonProps()}
          startIcon={<RefreshIcon />}
          onClick={handleSeed}
          disabled={isLoading}
        >
          {t('system.emails.seedDefaults')}
        </Button>
      }
    >
      {!isLoading && templates.length === 0 && (
        <Empty
          icon={<Icon icon="paperPlane" fontSize="large" />}
          title={t('system.emails.pageTitle')}
          description={t('system.emails.empty')}
          primaryAction={{
            label: t('system.emails.seedDefaults'),
            onClick: handleSeed,
          }}
        />
      )}
      {templates.length > 0 && <EmailTemplatesManager templates={templates} />}
    </DashboardListPageLayout>
  );
}
